function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon / Contact Us / report-streetlight");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Contact-Us-/-report-streetlight",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "street-light",
  transform: "translate(8.000000, 4.000000)",
  stroke: "#00148C"
}, /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 55.5,
  x2: 48,
  y2: 55.5,
  id: "Path",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.125,8.0625 L2.25,8.0625 C1.24898389,8.0625 0.4375,7.25101611 0.4375,6.25 L0.4375,2.625 C0.4375,1.62398389 1.24898389,0.8125 2.25,0.8125 L14.9375,0.8125 L14.9375,6.25 C14.9375,7.25101611 14.1260161,8.0625 13.125,8.0625 Z",
  id: "Path",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 24,
  y1: 40.6875,
  x2: 24,
  y2: 9.875,
  id: "Path",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24,9.875 C24,4.86991945 19.9425805,0.8125 14.9375,0.8125",
  id: "Path",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.875,8.0625 L45.75,8.0625 C46.7510161,8.0625 47.5625,7.25101611 47.5625,6.25 L47.5625,2.625 C47.5625,1.62398389 46.7510161,0.8125 45.75,0.8125 L33.0625,0.8125 L33.0625,6.25 C33.0625,7.25101611 33.8739839,8.0625 34.875,8.0625 Z",
  id: "Path",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24,9.875 C24,4.86991945 28.0574195,0.8125 33.0625,0.8125",
  id: "Path",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  strokeLinecap: "round",
  points: "33.0625 55.1875 14.9375 55.1875 18.5625 40.6875 29.4375 40.6875"
})));

var SvgReportStreetlight = function SvgReportStreetlight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReportStreetlight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/report-streetlight.ec0fb7d6.svg";
export { ForwardRef as ReactComponent };